import React from 'react';
import FiltersComponent from '../components/filters';

class Filters extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	render() {
		const { filters } = this.props;
		return (
			filters === [] ?
				null
				:
				<FiltersComponent
					{...this.props}
				/>
		)
	}
}

export default Filters;